import React, {
  PropTypes,
} from 'react';

import TweetEmbed from 'react-tweet-embed';

const LatestTweets = ({ tweets = [] }) => (
  <div className="feed tweets">
    <div className="col-md-12">
      <h3>Latest tweets</h3>
    </div>
    { tweets.map(tweet =>
      <div className="col-md-4" key={tweet.id_str}>
        <TweetEmbed
          options={{ conversation: 'none', cards: 'hidden' }}
          id={tweet.id_str}
        />
      </div>,
    )}
  </div>
);

LatestTweets.propTypes = {
  tweets: PropTypes.array.isRequired,
};

export default LatestTweets;



// WEBPACK FOOTER //
// ./src/components/latest-tweets/index.js